import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { JobService } from 'src/app/services/job.service';
import { AuthService } from 'src/app/services/auth.service';
import { EmailService } from 'src/app/services/email.service';
import { EmailSendModel, EmailTemplateModel } from 'src/app/models/email.model';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { TraceModel } from 'src/app/models/trace.model';
import { GifcardFisicaService } from 'src/app/services/giftcardFisica.service';

@Component({
  selector: 'app-ordersales-fisica-list',
  templateUrl: './ordersales-fisica-list.component.html',
  styleUrls: ['./ordersales-fisica-list.component.css']
})
export class OrdersalesFisicaListComponent implements OnInit, OnDestroy {
  constructor(private giftCardFisicaService: GifcardFisicaService,
      private messageService: MessageService,
      private excelService: ExcelService,
      private jobService: JobService,
      private authService: AuthService,
      private confirmationService: ConfirmationService,
      private emailService: EmailService,
      private traceService: TraceService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  colsTablaTrace: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  datasourceEmailFails: EmailSendModel[] = [];
  datasourceTrace: TraceModel[] = [];
  loading: boolean = false;
  currentUser: string;

  id_emailsend: number;
  email_sender: string;
  email_recipient: string;
  email_subject: string;
  email_bodyhtml: string;
  email_path_file: string;
  email_name_client: string;
  email_contacto: string;
  email_endpoint: string;
  emailValidateLast: string;
  sendMasivo: string;
  datasourceEmailTemplate: EmailTemplateModel[];

  ngOnInit() {
      this.currentUser = this.authService.getCurrentUser();
      this.createColumnsTablaGiftCardVirtual();
      this.createColumnsTablaEmailFails();
      this.createColumnsTableTrace();
      this.refreshData();
  }

  ngOnDestroy() {
      this.subscription.unsubscribe();
  }

  refreshData() {
      this.subscription.add(this.populateTableOrderSales());
      this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
      this.subscription.add(console.log("refreshdata"));
      this.subscription.add(
          timer(60000).subscribe(() => this.refreshData())
      );
  }

  createColumnsTablaGiftCardVirtual() {
      this.colsTablaOrderSales = [
          { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
          { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
          { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '40%', align: 'center' },
          { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
          { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
          { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' }
      ];
  }

  createColumnsTableTrace() {
      this.colsTablaTrace = [
          { field: 'ACTION', header: 'Acción', width: '10%', align: 'center' },
          { field: 'OBSERVATION', header: 'Observaciones', width: '60%', align: 'center' },
          { field: 'CREATIONUSER', header: 'Usuario', width: '10%', align: 'center' },
          { field: 'CREATIONDATE', header: 'Fecha Acción', width: '20%', align: 'center' }
      ];
  }

  createColumnsTablaEmailFails() {
      this.colsTablaEmailFails = [
          { field: 'ID_EMAILSEND', header: 'ID', width: '5%', align: 'center' },
          { field: 'NAME_FILE', header: 'Nombre Archivo', width: '15%', align: 'center' },
          { field: 'EMAIL_SEND', header: 'Correo', width: '15%', align: 'center' },
          { field: 'NAME_SEND', header: 'Enviado a', width: '15%', align: 'center' },
          { field: 'MESSAGE_SEND', header: 'Mensaje', width: '30%', align: 'center' },
          { field: 'STATUS_TEXT', header: 'Estado', width: '10%', align: 'center' }
      ];
  }

  populateTableOrderSales() {
      this.loading = true;
      this.giftCardFisicaService.GetGiftCardOrderSalesFisica().subscribe(
          (response: GiftCardOrderSalesModel[]) => {
              this.datasourceTablaOrderSales = response;
              this.totalOrderSales = this.datasourceTablaOrderSales.length;
              this.loading = false;
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
          }
      )
  }

  populateOrderSalesTrace(order) {
      let params = {
          "p_id_order_gift_card": order.ID_ORDER_SALES,
          "p_type_order_sales": this.giftCardFisicaService.TYPE_ORDER_SALES_FISICA
      };
      this.traceService.GetOrderSalesTraceByOrder(params).subscribe(
          (response: TraceModel[]) => {
              this.datasourceTrace = response;
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar trace de la orden de compra.' });
          }
      )
  }

  populateTableEmailFails(order: GiftCardOrderSalesModel) {
      let params = {
          "p_id_order_gift_card": order.ID_ORDER_SALES
      }
      this.emailService.GetGiftCardsEmailSendError(params).subscribe(
          (response: EmailSendModel[]) => {
              this.datasourceEmailFails = response;
              this.sendMasivo = this.datasourceEmailFails[0].TYPE_SEND;
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar email con errores.' });
          }
      );
  }

  onShowConfirmAnulate(order: GiftCardOrderSalesModel) {
      this.confirmationService.confirm({
          message: '¿Está seguro de anular la orden de compra?',
          accept: () => {
              this.anulateOrderSalesStatus(order);
          }
      });
  }

  anulateOrderSalesStatus(order: GiftCardOrderSalesModel) {
      this.loading = true;
      let params = {
          "p_id_order_gift_card": order.ID_ORDER_SALES,
          "p_id_modelo_gift_card": order.ID_MODELO_GIFT_CARD,
          "p_id_cliente_gift_card": order.ID_CLIENTE,
          "p_id_contact_gift_card": order.ID_CONTACT,
          "p_flg_activo": 0
      }
      this.giftCardFisicaService.UpdateOrderSalesFisicaStatus(params).subscribe(
          (response) => {
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación paso 1: exitoso.' });              
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al anular orden de compra.' });
          }
      )
  }

  anulateActivation(order: GiftCardOrderSalesModel) {
      let params = {
          "p_id_job": order.ID_JOB,
          "p_creationuser": this.currentUser,
          "p_type_operation": 3,
          "p_flg_activo": 0
      }
      this.jobService.UpdateGiftCardJobActivation(params).subscribe(
          (response) => {
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación realizada con éxito.' });
              this.populateTableOrderSales();
              this.loading = false;
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar Job.' });
          }
      )
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
      this.itemOrderSales = order;
      this.dlgOrderSales = true;
      this.populateOrderSalesTrace(order);
  }

  onShowDlgEmailFails(order: GiftCardOrderSalesModel) {
      this.itemOrderSales = order;
      this.dlgEmailFails = true;
      this.populateTableEmailFails(order);
  }

  onShowUpdateEmail(sendFail: EmailSendModel) {
      this.itemSendFails = sendFail;
      this.emailValidateLast = this.itemSendFails.EMAIL_SEND;
      this.dlgUpdateEmail = true;
  }

  downloadIMGModel() {
    saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }

  donwloadLiquidacion() {
    saveAs(this.itemOrderSales.IMG_LIQUIDACION, "liquidacion.jpg");
  }

  donwloadConstancia() {
    saveAs(this.itemOrderSales.IMG_CONSTANCIA, "constanciajpg");
  }

  donwloadGuia() {
    saveAs(this.itemOrderSales.IMG_GUIA, "guia.jpg");
  }
}